const calculateDiscount = (_voucher, initialAmount) => {
    let discount = 0
    if (_voucher.percentage_discount) {
        discount =
            (((initialAmount / 100) * _voucher.percentage_discount) / 100) * 100
    } else if (_voucher.discount_amount) {
        discount = _voucher.discount_amount * 100
    }

    // Apply max discount if max_discount is available(not 0)
    if (_voucher.max_discount && discount > _voucher.max_discount * 100) {
        discount = _voucher.max_discount * 100
    }

    return discount
}

export { calculateDiscount }
